import { env } from "@/lib/env";

/** Which social sign-in providers the API has credentials for. */
export interface AuthFeatures {
  appleSignInEnabled: boolean;
  googleSignInEnabled: boolean;
}

/**
 * Build-time social sign-in flags.
 *
 * Both halves come from one Pulumi source
 * (apps/infrastructure/stacks/vercel/sso-config.ts), which decides the API's
 * credentials and this bundle's flags together — so the two cannot drift into
 * a button the server can't complete.
 *
 * Read at module scope, not through a hook: the flags change only with a
 * deployment, so a per-mount fetch bought nothing and left the sign-up page
 * unable to produce a complete first paint. Constants are what let the page be
 * prerendered (scripts/prerender.mjs) into markup a crawler can read.
 *
 * Unset means off. An environment that never sets the flag hides the button
 * rather than guessing, so a provider the server can't complete a sign-in for
 * never dead-ends on click.
 */
export const authFeatures: AuthFeatures = {
  appleSignInEnabled: env.VITE_APPLE_SIGN_IN_ENABLED ?? false,
  googleSignInEnabled: env.VITE_GOOGLE_SIGN_IN_ENABLED ?? false,
};
